import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'
import httpStatus from 'http-status';

export const groupService = {
  getAll
};

function getAll() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: authHeader(),
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/group`,
  }).then((response) => {
    if (response && response.status === httpStatus.OK) {
      return response.data.data;
    }
  })
}